import { useMutation } from 'react-query';
import axios from 'axios';

import { AwsConfigApiGateway } from '@/utils/config/api';

interface CheckUserStatusRequest {
  email: string;
}

interface CheckUserStatusResponse {
  email: string;
  userStatus: string;
  canResetPassword: boolean;
  message: string;
}

export function useCheckUserStatus() {
  return useMutation<CheckUserStatusResponse, Error, CheckUserStatusRequest>(async (data) => {
    const response = await axios.post<CheckUserStatusResponse>(
      `${AwsConfigApiGateway.pooledTenantApiUrl}/auth/check-user-status`,
      data,
      {
        headers: {
          'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
          'Content-Type': 'application/json',
        },
      },
    );
    return response.data;
  });
}
